import config from "../../config"
import RequestService from "../RequestService"

const fetchReservationImports = (successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrlV2}/reservation_imports`, successCallback, failureCallback)
}

export default fetchReservationImports;